import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CyberReplayStatus, CyberScenarioSummary } from '../models/cyber-scenario.model';
import { environment } from '../../environments/environment';

/**
 * Drives scenario replays on the cyber page.
 *
 * Uncached like {@link CyberTopologyService}, and for a stronger reason: `status` is polled
 * precisely because it changes several times a second while a replay runs.
 */
@Injectable({ providedIn: 'root' })
export class CyberScenarioService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiBaseUrl}/cyber/scenarios`;

  list(): Observable<CyberScenarioSummary[]> {
    return this.http.get<CyberScenarioSummary[]>(this.apiUrl);
  }

  status(): Observable<CyberReplayStatus> {
    return this.http.get<CyberReplayStatus>(`${this.apiUrl}/replay`);
  }

  start(id: string): Observable<CyberReplayStatus> {
    return this.http.post<CyberReplayStatus>(`${this.apiUrl}/${id}/replay`, {});
  }

  stop(): Observable<CyberReplayStatus> {
    return this.http.delete<CyberReplayStatus>(`${this.apiUrl}/replay`);
  }
}
